<template>
  <div class="flex flex-col gap-0.5">
    <div class="bg-white">
      <div class="container max-w-screen-lg py-2 sm:py-4">
        <div class="flex flex-row items-center justify-between gap-4 sm:gap-10">
          <div class="flex w-full items-center justify-center gap-4 sm:w-auto">
            <nuxt-link class="flex-shrink-0" to="/">
              <div class="text-center sm:text-start">
                <h1 class="font-headline text-2xl leading-tight text-slate-darker lg:text-2xl">
                  Rädda Djuren-klubben
                </h1>
                <p class="text-base text-slate-dark max-sm:hidden lg:text-base">
                  För en snällare framtid för djuren
                </p>
              </div>
            </nuxt-link>
          </div>

          <div class="flex-shrink-0">
            <search-input></search-input>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white text-sm max-sm:hidden">
      <div class="container max-w-screen-lg py-2">
        <div class="grid grid-cols-8 md:gap-4 lg:gap-6">
          <div class="col-start-7 flex items-center justify-center">
            <div class="relative">
              <span class="invisible">&nbsp;</span>
              <div
                class="absolute -right-1 inline-flex items-center gap-2 whitespace-nowrap text-slate-darker"
              >
                <span>
                  <span class="font-bold">Är du vuxen?</span>
                  {{ ' ' }}
                  <span>Besök vår sida för vuxna</span>
                </span>
                <icon-arrow-right class="h-6 w-6" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white max-sm:hidden">
      <div class="container max-w-screen-lg py-2">
        <the-header-menu ref="menu"></the-header-menu>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import TheHeaderMenu from './TheHeaderMenu.vue'
</script>
